<ion-tabs (ionTabsWillChange)="willChange($event)" #homeTabs>
  <div role="navigation">
    <ion-tab-bar slot="bottom" *ngIf="participationOpenCount !== undefined">
      <ion-tab-button
        tabindex="0"
        tab="feed"
        role="tab"
        [class.tab-selected]="homeTabs.getSelected() === 'feed'"
        [attr.aria-selected]="homeTabs.getSelected() === 'feed'"
        [attr.aria-label]="'tab.feed' | translate"
      >
        <ion-icon
          aria-hidden="true"
          src="/assets/icons/navigation/home.svg"
        ></ion-icon>
        <ion-ripple-effect></ion-ripple-effect>
      </ion-tab-button>
      <ion-tab-button
        tabindex="0"
        tab="search"
        role="tab"
        [class.tab-selected]="homeTabs.getSelected() === 'search'"
        [attr.aria-selected]="homeTabs.getSelected() === 'search'"
        [attr.aria-label]="'tab.search' | translate"
        *ngIf="!isProjectApp"
      >
        <ion-icon
          aria-hidden="true"
          src="/assets/icons/navigation/search.svg"
        ></ion-icon>
        <ion-ripple-effect></ion-ripple-effect>
      </ion-tab-button>
      <ion-tab-button
        tab="project"
        tabindex="0"
        role="tab"
        [class.tab-selected]="homeTabs.getSelected() === 'project'"
        [attr.aria-selected]="homeTabs.getSelected() === 'project'"
        [attr.aria-label]="'tab.project' | translate"
        *ngIf="isProjectApp"
      >
        <ion-icon src="/assets/icons/navigation/project.svg"></ion-icon>
        <ion-ripple-effect></ion-ripple-effect>
      </ion-tab-button>
      <ion-tab-button
        tabindex="0"
        tab="participation"
        role="tab"
        [class.tab-selected]="homeTabs.getSelected() === 'participation'"
        [attr.aria-selected]="homeTabs.getSelected() === 'participation'"
        [attr.aria-label]="('tab.participation' | translate) + ', ' + participationOpenCount + ' ' + ('participation.open' | translate)"
      >
        <ion-icon
          aria-hidden="true"
          src="/assets/icons/navigation/participation.svg"
        ></ion-icon>
        <span
          aria-hidden="true"
          *ngIf="participationOpenCount > 0 && participationOpenCount <= 99"
        >
          {{ participationOpenCount }}
        </span>
        <span aria-hidden="true" *ngIf="participationOpenCount > 99"> 99 </span>
        <ion-ripple-effect></ion-ripple-effect>
      </ion-tab-button>
      <ion-tab-button
        tabindex="0"
        tab="projects"
        role="tab"
        [class.tab-selected]="homeTabs.getSelected() === 'projects'"
        [attr.aria-selected]="homeTabs.getSelected() === 'projects'"
        [attr.aria-label]="'tab.projects' | translate"
        *ngIf="!isProjectApp"
      >
        <ion-icon
          aria-hidden="true"
          src="/assets/icons/navigation/projects.svg"
        ></ion-icon>
        <ion-ripple-effect></ion-ripple-effect>
      </ion-tab-button>
      <ion-tab-button
        tabindex="0"
        tab="settings"
        role="tab"
        [class.tab-selected]="homeTabs.getSelected() === 'settings'"
        [attr.aria-selected]="homeTabs.getSelected() === 'settings'"
        [attr.aria-label]="'tab.settings' | translate"
      >
        <ion-icon
          aria-hidden="true"
          src="/assets/icons/navigation/settings.svg"
        ></ion-icon>
        <ion-ripple-effect></ion-ripple-effect>
      </ion-tab-button>
    </ion-tab-bar>
  </div>
</ion-tabs>
